import styled, { css } from 'styled-components';
import { spaceMixin, token } from '@zillow/constellation';

export const StyledTourCardImage = styled.div<{ md: boolean; full: boolean; clickable: boolean }>`
  position: relative;
  height: 140px;

  ${(props) =>
    props.md &&
    css`
      height: 170px;
    `}

  ${(props) =>
    props.full &&
    css`
      height: 100%;
    `}

    ${(props) =>
    props.clickable &&
    css`
      cursor: pointer;
    `}

    .TourCardImage-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .TourCardImage-hidden {
    z-index: 1;
    padding: 3px 7px;
    color: ${token('colors.white')};
    background: grey;
  }

  .TourCardImage-container {
    height: 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-color: ${token('colors.gray200')};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .TourCardImage-selected {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    position: absolute;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.5) 0px 3px 9px 0px;
    z-index: 1;
    top: ${spaceMixin('xs')};
    right: ${spaceMixin('xs')};
  }
`;
